import React from "react";
import TextAreaAutosize from 'react-textarea-autosize';
import { WithTranslation, withTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";

import { IOperationData, TranslationKeyType, ITextinputOperation } from "../../../constants/types";

import './TextInputOperation.scss'

interface Props extends WithTranslation{
    operation: ITextinputOperation,
    data: IOperationData,
    onChange: (changes: IOperationData) => void
};

//minimum length in order to "OK" operation
const minInputLength = 3;

class TextInputOperation extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    onSelectSuggestion = (value: string) => {
        const { data, onChange } = this.props;
        
        onChange({ 
            ...data,
            value: value,
            OK: value.length >= minInputLength
        });
    }

    renderSuggestions(suggestions: TranslationKeyType[]) {
        const { t, data } = this.props;

        return <Row className="text-input-suggestions">
            {suggestions.map(suggestion => {
                const translated = t(suggestion as unknown as TemplateStringsArray);
                return <Col xs={12} className={`text-input-suggestion fade-in ${translated == data.value ? "suggestion-picked" : ""}`} onClick={() => this.onSelectSuggestion(translated)}>
                    {translated}
                </Col>;
            })}
        </Row>
    }

    onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const { data, onChange } = this.props;
        const value = e.target.value;
        
        onChange({ 
            ...data,
            value: value,
            OK: value.length >= minInputLength
        });
    }

    render() {
        const { t, operation, data } = this.props;
        
        return <div className="render-text-input-operation">
            <TextAreaAutosize placeholder={t("general.write-here")} value={data.value} onKeyDown={(e) => { if(e.key === 'Enter') { e.preventDefault(); } }} onChange={this.onChange} className="text-input-input"/>
            <div className="text-input-divider"/>
            {this.renderSuggestions(operation.suggestions)}
        </div>;
    }
};

export default withTranslation()(TextInputOperation);